import { render, staticRenderFns } from "./BreakdownPercentage.vue?vue&type=template&id=0b73fb38"
import script from "./BreakdownPercentage.vue?vue&type=script&lang=js"
export * from "./BreakdownPercentage.vue?vue&type=script&lang=js"
import style0 from "./BreakdownPercentage.vue?vue&type=style&index=0&id=0b73fb38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports